import axiosClient from '@aspida/axios';
import { appAxios } from '../libs/axios/appAxios';
import api from '../api/job/$api';

export const apiClient = api(axiosClient(appAxios));
